import React from 'react'
import iconCog from 'images/icons/cog.svg'
import iconPlus from 'images/icons/plus.svg'
import { CSSTransition } from 'react-transition-group'
import Very from "../helpers/request_wrapper";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerMenuVisible: false,
      mobileMenuVisible: false
    };
  }

  componentDidMount() {
    this.checkUrl();
  }

  checkUrl = () => {
    const path = window.location.pathname
    return path.split('/')[1]
  }

  hideHeaderMenu = () => {
    this.setState({ headerMenuVisible: false })
  }

  toggleHeaderMenu = () => {
    this.setState({ headerMenuVisible: !this.state.headerMenuVisible })
  }

  toggleMobileMenu = () => {
    this.setState({ mobileMenuVisible: !this.state.mobileMenuVisible })
  }
  userName = (currentUser) =>{
    console.log(currentUser)
    return currentUser.first_name === null ? currentUser.email : `${currentUser.first_name} ${currentUser.last_name}`
  }

  render() {
    const {
      headerMenuVisible,
      mobileMenuVisible
    } = this.state

    const {
      buttonText,
      buttonUrl,
      currentUser,
      limitedView,
      payed,
      personaName,
      canUnlock,
      personaId,
      showPrintBtn,
    } = this.props;

    const navigation = (
      <ul className="flex sfpro-regular sm-block sm-center text-tuna">
        <li className="mr-25 sm-m0 sm-mb3">
          <a
            className={`${(this.checkUrl() === '' || this.checkUrl() === 'personas') && 'text-violet-red' || ''} relative`}
            href="/personas"
          >
            Personas

            <div
              className="absolute bg-violet-red circle flex flex-center flex-justify-center h6 text-white"
              style={{ height: 20, right: '-15px', top: '-10px', width: 20 }}
            >
              {currentUser.persona_limit}
            </div>
          </a>
        </li>

        <li className="mr-25 sm-m0 sm-mb3">
          <a
            className={`${this.checkUrl() === 'media_plans' ? 'text-violet-red' : ''} relative`}
            href="/media_plans"
          >
            Media Plans

            <div
              className="absolute bg-violet-red circle flex flex-center flex-justify-center h6 text-white"
              style={{ height: 20, right: '-15px', top: '-10px', width: 20 }}
            >
              {currentUser.media_plan_limit}
            </div>
          </a>
        </li>

        <li className="mr-25 sm-m0 sm-mb3">
          <a className={this.checkUrl() === 'pricing' ? 'text-violet-red' : ''} href="/pricing">Pricing</a>
        </li>

        <li className="mr-25 sm-m0 sm-mb3">
          <a href="/resources">Resources</a>
        </li>

        <li className="mr-25 sm-m0">
          <a href="https://lussy.io" target="_blank">About Us</a>
        </li>
      </ul>
    );

    const unlockPersona = () => {
      Very.post(`/personas/${personaId}/unlock`).then(res => {
        window.location.replace(`/personas/${personaId}`)
      }, error => {

      })
    };

    const Button = (
      <>
        {canUnlock && !payed ? <a
            className="btn btn--primary btn--fs-13 btn--h-32 md-width-auto w-180"
            onClick={unlockPersona}
          >
            <span className="md-hide">Unlock</span>
          </a> :
          <a
            className="btn btn--primary btn--fs-13 btn--h-32 md-width-auto w-180"
            href={buttonUrl}
          >
            {!limitedView && <img alt="" className="mr1 md-m0" src={iconPlus} />}
            {limitedView && !payed && <span className="hidden sm-show">$</span>}
            <span className="md-hide">{buttonText}</span>
          </a>
        }

      </>
    );

    return (
      <React.Fragment>
        <header className="bg-white border-bottom border-gallery col-12 fixed flex flex-center flex-justify left-0 px-40 top-0 z5" style={{ height: '80px' }}>
          <React.Fragment>
            <CSSTransition
              in={headerMenuVisible}
              classNames="fade"
              timeout={600}
              unmountOnExit
            >
              <div
                className="bg-wild-sand-o-50 bottom-0 fixed left-0 right-0 top-0 z3"
                onClick={this.hideHeaderMenu}
              />
            </CSSTransition>

            <div className="px-40 sm-p0">
              <a className="logo" href="/" />
            </div>

            <div className="flex flex-auto flex-center flex-justify md-flex-justify-end">
              <nav className="header-navigation md-hide">
                {navigation}
              </nav>

              <CSSTransition
                in={mobileMenuVisible}
                classNames="slide-down"
                timeout={600}
                unmountOnExit
              >
                <nav className="header-navigation">
                  {navigation}
                </nav>
              </CSSTransition>

              <div className="flex flex-center">
                {showPrintBtn && (
                  <div className="md-hide">
                    <a
                      aria-label={payed ? null : 'You can download your persona after purchase'}
                      data-balloon-pos={payed ? null : 'down'}
                      className={`btn ${payed ? 'btn--primary' : 'btn--primary--wisp-pink'} btn--fs-13 btn--h-32 mr-10 w-180`}
                      onClick={(e) => {
                        e.preventDefault()

                        if (payed) window.print()
                      }}
                    >
                      Download pdf
                    </a>
                  </div>
                )}

                <div className="relative mr-10">
                  <button
                    className="btn btn--outlined btn--fs-13 btn--lh-30 btn--h-32 box-shadow-box flex md-width-auto w-180"
                    onClick={this.toggleHeaderMenu}
                    type="button"
                  >
                    <span className="flex-auto md-hide truncate">
                      {this.userName(currentUser)}
                    </span>

                    <img alt="" className="ml1 md-m0" src={iconCog} />
                  </button>

                  <CSSTransition
                    in={headerMenuVisible}
                    classNames="fade-transform-top"
                    timeout={600}
                    unmountOnExit
                  >
                    <div
                      className="absolute bg-white box-shadow-dropdown h5 mt-5 px-30 py-20 right-0 rounded-6 sfpro-regular triangle-top-right-24-white-5 top-100 z4"
                      style={{ minWidth: '205px' }}
                    >
                      <a className="block mb-20 text-tuna" href={`/users/${this.props.currentUser.id}`}>Profile settings</a>
                      <a className="block mb-20 text-tuna" href="/transactions_history">Transactions History</a>
                      <a className="block mb-20 text-tuna" href="/credit_cards">Credit Card</a>
                      <a className="block mb-20 text-tuna" href="/subscriptions">Subscriptions</a>
                      <a className="block mb-20 text-tuna" href={`/users/${this.props.currentUser.id}/change_password`}>Change Password</a>
                      <a className="block mb-20 text-tuna" href="/privacy_policy">Privacy Policy</a>
                      <a className="block mb-20 text-tuna" href="/terms_and_conditions">Terms And Conditions</a>
                      <a className="block text-tuna" data-method="delete" href="/users/sign_out">Logout</a>
                    </div>
                  </CSSTransition>
                </div>

                {Button}

                <a
                  className={`btn-nav ${mobileMenuVisible && 'active'}`}
                  href="#"
                  onClick={this.toggleMobileMenu}
                >
                  <span />
                </a>
              </div>
            </div>
          </React.Fragment>
        </header>
      </React.Fragment>
    );
  }
}

export default Header